import * as React from "react";
import { EntityCardStore } from "src/pages/EntityCardPage/EntityCardStore";
import { cvtError, onError } from "src/common/onError";
import { t } from "i18next";
import { EntityEditorModal } from "src/components/EntityEditor";
import { observer } from "mobx-react-lite";
import { ZEntity } from "src/types/ZEntity";
import { ZUid } from "src/types/zUid";
import { Pl2CurrentTask } from "./Planning2Table/Planning2TableStore";
import { deletePlanning2Tasks, updatePlanning2Task } from "../apiPlanning2";

type PropsPlanning2CurrentTask = {
  currentTask: Pl2CurrentTask | null | undefined;
  objectServiceId: ZUid;
  close: () => void;
  reload: () => void;
  onDeleteSuccess: () => void;
};

export const Planning2CurrentTask: React.FC<PropsPlanning2CurrentTask> =
  observer((props) => {
    const { currentTask, objectServiceId, close, reload, onDeleteSuccess } =
      props;
    const [store, setStore] = React.useState<EntityCardStore | null>(null);

    const onSuccess = () => {
      reload();
      close();
    };

    React.useEffect(() => {
      if (currentTask) {
        try {
          const fnUpdate = async (taskEntity: ZEntity): Promise<ZEntity> =>
            updatePlanning2Task(objectServiceId, taskEntity);
          const newStore = new EntityCardStore({ fnUpdate });
          newStore.init(currentTask.id);
          setStore(newStore);
        } catch (e) {
          onError(cvtError(e));
          setStore(null);
          close();
        }
      } else {
        setStore(null);
      }
    }, [currentTask?.id, objectServiceId]);

    const onDelete = () => {
      // TODO: в МДМ реализация намного удачнее. Там колбэк асинхронный.
      // К сожалению, здесь придётся писать обработку полного цикла.
      // Кроме того, гораздо лучше было бы, если бы пока происходит удаление, висело заблокированное окно конфирма.
      // Это гарантировало бы невозможность выполнения каких-то других операций во время удаления.
      // Но сейчас конфирм закрывается и крутилка показана на кнопке удаления. что не запрещает другие действия
      // (которые всё равно не имеют смысла для удаляемого объекта)
      const doDelete = async () => {
        const taskId = currentTask?.id;
        if (taskId) {
          try {
            store?.setDeleting(true);
            await deletePlanning2Tasks([taskId]);
            onDeleteSuccess();
            onSuccess();
          } finally {
            store?.setDeleting(false);
          }
        }
      };
      doDelete().catch(onError);
    };

    return (
      <EntityEditorModal
        store={store}
        modalProps={{
          open: !!currentTask,
          onCancel: close,
        }}
        editorProps={{
          submitText: t("Apply"),
          onSuccess,
          deleting: store?.deleting,
          onDelete,
        }}
      />
    );
  });
